import game from './Classes/Game/GameInstance'


window.lgdLobby = game;



// If lobbyLoader is already defined it means that
// there was a script requesting lobby loader
// before it was defined by this script.
let wasDefined = (typeof window.lgdLobbyLoader !== 'undefined');

// If lobbyloader was defined we need to check the
// buffer for existing callbacks and call them.
if (wasDefined) {

  // loop all items in the array and run their callback
  let ln = window.lgdLobbyLoader.length;
  for (let i = 0; i < ln; i++) {
    window.lgdLobbyLoader[i](game);
  }

}

// Override the standard push method to run the
// callback.
window.lgdLobbyLoader = [];
window.lgdLobbyLoader.push = function(callback) {
  callback(game);
}
